import type { ImageTextBlockContent } from "../types"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { Textarea } from "@/components/ui/textarea"
import { Card, CardContent, CardHeader } from "@/components/ui/card"
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"

interface ImageTextBlockEditorProps {
  content: ImageTextBlockContent | null
  onChange: (content: ImageTextBlockContent) => void
}

export function ImageTextBlockEditor({
  content,
  onChange,
}: ImageTextBlockEditorProps) {
  const c = content ?? {}
  const update = (partial: Partial<ImageTextBlockContent>) =>
    onChange({ ...c, ...partial })

  return (
    <Card>
      <CardHeader>
        <h3 className="text-base font-medium">Image + Text</h3>
      </CardHeader>
      <CardContent className="space-y-4">
        <div>
          <Label>Heading</Label>
          <Input
            value={c.heading ?? ""}
            onChange={(e) => update({ heading: e.target.value })}
            placeholder="Our mission"
          />
        </div>
        <div>
          <Label>Body</Label>
          <Textarea
            value={c.body ?? ""}
            onChange={(e) => update({ body: e.target.value })}
            placeholder="Content text"
            rows={4}
            className="resize-none"
          />
        </div>
        <div>
          <Label>Image URL</Label>
          <Input
            value={c.image_url ?? ""}
            onChange={(e) => update({ image_url: e.target.value || undefined })}
            placeholder="https://..."
          />
        </div>
        <div>
          <Label>Image Position</Label>
          <Select
            value={c.image_position ?? "left"}
            onValueChange={(v) =>
              update({ image_position: v as "left" | "right" })
            }
          >
            <SelectTrigger>
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="left">Left</SelectItem>
              <SelectItem value="right">Right</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <div>
          <Label>CTA Text</Label>
          <Input
            value={c.cta_text ?? ""}
            onChange={(e) => update({ cta_text: e.target.value })}
            placeholder="Learn more"
          />
        </div>
        <div>
          <Label>CTA URL</Label>
          <Input
            value={c.cta_url ?? ""}
            onChange={(e) => update({ cta_url: e.target.value })}
            placeholder="https://..."
          />
        </div>
      </CardContent>
    </Card>
  )
}
